import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { Breakpoints } = constants.breakpoints;
const { mediaQuery: breakpoint } = mediaQueryStyles;
const { ui } = constants.colors;
const { fontSize } = typographyStyles;

export const containerCss = {
  border: "none",
  padding: 0,
  margin: 0,
  legend: {
    ...typographyStyles.textSObj,
    fontWeight: "bold",
  },
};

export const listCss = {
  marginTop: "10px",
  marginBottom: "10px",
  [breakpoint.downTo(Breakpoints.sm)]: {
    width: "fit-content",
    columns: "2",
  },
};

export const checkboxCustomCss = {
  root: {
    display: "flex",
  },
  checkedBox: {
    paddingRight: "0",
  },
  emptyCheckbox: {
    paddingRight: "0",
  },
  labelText: {
    paddingLeft: "12px",
  },
};

export const errorCss = {
  ...fontSize.textS,
  color: ui.red[600],
  marginLeft: "1rem",
  fontWeight: "bold",
};
